import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import "./index.js";
import { render } from '@testing-library/react';

function App() {

  const [sessionLength, setSessionLength] = useState(25);
  const [breakLength, setbreakLength] = useState(5);

  const [timeName, setTimeName] = useState("Session");
  const [running, setRunning] = useState(false);
  const [intervalNumb, setIntervalNumb] = useState();
  const [timer, setTimer] = useState(secondsToMmss(sessionLength * 60));

  const [pausedTimer, setpausedTimer] = useState();
  const [lastMinute, setLastMinute] = useState(false);

  const [zero, setZero] = useState(false);
  const [counter, setCounter] = useState(0);

  const audioRef = useRef();

  // TURN SECONDS TO MM:SS SCHEMA //
  function secondsToMmss(totalSec) {
    let seconds = totalSec % 60;
    let minutes = (totalSec - seconds) / 60;
    seconds = seconds < 10 ? `0${seconds}` : seconds;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${minutes}:${seconds}`;
  }

  // INCREASE TIMER LENGTH //
  const increment = (numb, whichOne) => {
    if (counter === 0 && !running && !pausedTimer) {
      if (whichOne === "break") {
        if (breakLength < 60) {
          setbreakLength(numb + 1);
        }
      } else {
        if (sessionLength < 60) {
          setSessionLength(numb + 1);
          if (sessionLength < 9) {
            setTimer(`0${sessionLength + 1}:00`);
          } else {
            setTimer(`${sessionLength + 1}:00`);
          }
        }
      }
    }
  };

  // DECREASE TIMER LENGTH //
  const decrement = (numb, whichOne) => {
    if (counter === 0 && !running && !pausedTimer) {
      if (whichOne === "break") {
        if (breakLength > 1) {
          setbreakLength(numb - 1);
        }
      } else {
        if (sessionLength > 1) {
          setSessionLength(numb - 1);
          if (sessionLength < 11) {
            setTimer(`0${sessionLength - 1}:00`);
          } else {
            setTimer(`${sessionLength - 1}:00`);
          }
        }
      }
    }
  };

  // RESET VARIABLES //
  const resetAll = () => {
    setRunning(false);
    clearInterval(intervalNumb);
    setSessionLength(25);
    setbreakLength(5);
    setTimer(secondsToMmss(25 * 60));
    setLastMinute(false);
    setpausedTimer();
    setTimeName("Session");
  };

  // TIME RUNNING FUNCTION //
  const timerRun = () => {
    // IF TIMER NO RUNNING (first launch or paused)
    if (!running) {
      setRunning(true);
      let timetoDisplay = sessionLength * 60;

      if (pausedTimer !== undefined) {
        timetoDisplay = pausedTimer;
      }
      if (zero) {
        timetoDisplay =
          timeName === "Session" ? sessionLength * 60 : breakLength * 60;
        setCounter(counter + 1);
      }

      let timerRunning = setInterval(() => {
        timetoDisplay--;
        timetoDisplay <= 60 && setLastMinute(true);
        setTimer(secondsToMmss(timetoDisplay));
        setpausedTimer(timetoDisplay);
        setIntervalNumb(timerRunning);
      }, 1000);
    }

    // IF TIMER RUNNING
    else {
      setRunning(false);
      clearInterval(intervalNumb);
    }
  };

  // TIMER IS 00:00 //
  useEffect(() => {
    if (timer === "00:00") {
      audioRef.current.play();

      if (counter > 1) {
        resetAll();
      } else {
        setRunning(false);
        clearInterval(intervalNumb);
        setTimeout(() => {
          setLastMinute(false);
          if (timeName === "Session") {
            setTimeName("Break");
            setTimer(secondsToMmss(breakLength * 60));
            // setTimer(`${breakLength}:00`);
          } else {
            setTimeName("Session");
            setTimer(secondsToMmss(sessionLength * 60));
            // setTimer(`${sessionLength}:00`);
          }
          setZero(true);
        }, 500);
      }
    }
    if (zero && counter < 2) {
      timerRun();
      setZero(false);
    }
  }, [timer, zero, counter]);

const style={

lengthContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '70%',
    fontSize: '1.3rem'
},
sessionTitle: {
  fontSize: '2rem',
  marginBottom: '0.7rem',
  color:  lastMinute ? '#F8B500': '#fff'
},
timeContainer: {
  display: 'flex',
  width: '60%',
  justifyContent: 'space-around',
  alignItems: 'baseline',
},
icon: {
  fontSize: '5.0rem',
  padding: '0 1rem',
  cursor: 'pointer',
  marginBottom: '1rem'
},
counter: {
  fontSize: '3.5rem',
  marginBottom: '1.2rem',
  color:  lastMinute ? '#DBFF3D': '#9AB3F5'
},
counterCommand: {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1.6rem'
},
playPause: {
  padding: '0 0.2rem'
},
breakContainer: {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
},
}
  return (
    <div className="container">
      <h1 className="title">O'CLOCK</h1>
      <section className="lengthContainer">
        <div id="break-label" style={style.breakContainer}>
          <p className="para">Break Length</p>
          <div style={style.timeContainer}>
            <i className="fa fa-arrow-circle-o-up"
              id="break-increment"
              style={style.icon}
              onClick={() => increment(breakLength, "break")}></i>
            <p id="break-length">{breakLength}</p>
            <i className="fa fa-arrow-circle-o-down"
              id="break-decrement"
            style={style.icon}
              onClick={() => decrement(breakLength, "break")}></i>
          </div>
        </div>
        <div id="session-label" className="sessionContainer">
          <p className="para">Session Length</p>
          <div style={style.timeContainer}>
            <i className="fa fa-arrow-circle-o-up"
              id="session-increment" style={style.icon} onClick={() =>
                increment(sessionLength, "length")}></i>
            <p id="session-length">{sessionLength}</p>
            <i className="fa fa-arrow-circle-o-down"
              id="session-decrement"
            style={style.icon}
              onClick={() => decrement(sessionLength, "length")}></i>
          </div>
        </div>
      </section>
      <section id="timer-label" className="timeLeft">
        <p style={style.sessionTitle}>{timeName}</p>
        <div id="time-left"style={style.counter}>{timer}</div>
        <div style={style.counterCommand}>
          <div id="start_stop" onClick={timerRun}>
            <i className="fa fa-play fa-2x" style={{ ...style.icon,...style.playPause}}></i>
            <i className="fa fa-pause fa-2x" style={{ ...style.icon, ...style.playPause}}></i>
          </div>
          <i className="fa fa-refresh fa-2x"
            id="reset"
            style={{ ...style.icon, marginLeft: "1.2rem"}}
            onClick={resetAll}></i>
        </div>
        {/* <audio src="https://bigsoundbank.com/UPLOAD/mp3/1417.mp3" ref={audioRef} id="beep"></audio> */}
        <audio
          src="https://bigsoundbank.com/UPLOAD/mp3/0925.mp3" ref={audioRef}
          id="beep"></audio>
      </section>
      <p>FCC Frontend &#169; 2021</p>
    </div>
  );
}

export default App;
